import type { Theme } from "@/v1-console/theme/theme.types"
import {
  THEME_NAMES
} from "@/v1-console/theme/theme.constants"

export function assertIsTheme(obj: any): obj is Theme {
  return obj?.name && Object.keys(THEME_NAMES).includes(obj.name)
}
